export default __webpack_public_path__ + "static/media/ic_exit_to_app_24px.8da93732.svg";